import { createSlice } from '@reduxjs/toolkit';
import { Setting, SettingKey } from '../../models/setting.model';
import { ContentModel } from '../../models/content.model';
import { Booking } from '../../models/booking.model';
import { AvailabilityDay } from '../../models/availability.model';
import defaultContent from 'utils/data';

interface PublicState {
    availability: AvailabilityDay[];
    settings: Setting[];
    booking: Booking | null;
    redirectUrl: string | null;
    bookingCreateLoading: boolean;
    loading: boolean;
    bookingError: string | null;
    content: ContentModel | null;
}

const initialState: PublicState = {
    availability: [],
    settings: [],
    booking: null,
    redirectUrl: null,
    bookingCreateLoading: false,
    loading: false,
    bookingError: null,
    content: defaultContent as unknown as ContentModel,
};

const publicSlice = createSlice({
    name: 'public',
    initialState,
    reducers: {
        createBooking: (state) => {
            state.bookingCreateLoading = true;
        },
        createBookingSuccess: (state, action) => {
            state.booking = action.payload;
            state.redirectUrl = action.payload.redirectUrl;
            state.bookingCreateLoading = false;
        },
        createBookingFailed: (state, action) => {
            state.bookingCreateLoading = false;
            state.bookingError = action.payload;
        },
        getAvailability: (state) => {
            state.loading = true;
        },
        getAvailabilitySuccess: (state, action) => {
            state.availability = action.payload.monthData || [];
            state.loading = false;
        },
        getAvailabilityFailed: (state) => {
            state.loading = false;
        },
        getPublicSettings: (state) => {
            state.loading = true;
        },
        getPublicSettingsSuccess: (state, action) => {
            state.settings = action.payload.filter((setting: Setting) => setting.setting_key !== SettingKey.PAGE_CONTENT);
            state.content =  action.payload.find((setting: Setting) => setting.setting_key === SettingKey.PAGE_CONTENT)?.setting_value as unknown as ContentModel || defaultContent;
            state.loading = false;
        },
        getPublicSettingsFailed: (state) => {
            state.loading = false;
            state.content = defaultContent as unknown as ContentModel;
            state.settings = [];
        }
    },
});

export const {
    createBooking,
    createBookingSuccess,
    createBookingFailed,
    getAvailability,
    getAvailabilitySuccess,
    getAvailabilityFailed,
    getPublicSettings,
    getPublicSettingsSuccess,
    getPublicSettingsFailed,
} = publicSlice.actions;

export default publicSlice.reducer; 